import { Component } from '@angular/core'

@Component({
    templateUrl: './with-breadcrumb-dashboard.component.html'
})

export class WithBreadcrumbDashboardComponent {
}  
